module.exports = __webpack_public_path__ + "img/stamp-paid.dd7d5470.png";